import {ReactNode} from 'react'

export const CHATBOT_SOURCES = {
    CHATBOT: 'Chatbot',
    USER: 'User'
} as const

export const CHATBOT_CANCELLATION_REASONS = {
    CREATOR_DONT_MATCHING_AVAIBILITIES: 2,
    CREATOR_LOCATED_FAR_AWAY: 3,
    CREATOR_NOT_AVAILABLE_ANYMORE: 4,
    CREATOR_DONT_FEEL_COMFORTABLE: 5,
    CREATOR_ACCEPTED_MISTAKE: 6,
    CREATOR_COVID_19: 7,
    CREATOR_OTHER: 8,
    HOST_NEVER_RESPONDED: 10,
    HOST_STOPPED_RESPONDING: 11,
    HOST_NOT_INTERESTED_ANYMORE: 12,
    HOST_NO_SHOW: 13,
    HOST_LISTING_NOT_READY: 14,
    HOST_UNAVAILABLE_3_MONTHS: 15,
    HOST_NOT_COMFORTABLE_6_MONTHS: 16,
    HOST_RESCHEDULED_3_TIMES: 17,
    HOST_OTHER: 18,
    HOST_SIGNED_MISTAKE: 19,
    HOST_PRICE_HIGH: 20,
    HOST_CHANGED_MIND: 21,
    HOST_IM_NOT_INTERESTED_ANYMORE: 22,
    HOST_FOUND_ANOTHER_PHOTOGRAPHER: 23,
    HOST_MY_LISTING_NOT_READY: 24,
    HOST_NOT_READY: 25,
    HOST_PHOTOGRAPHER_UNRESPONSIVE: 26,
    HOST_DONT_FEEL_COMFORTABLE_PHOTOGRAPHER: 27,
    HOST_LISTING_DOESNT_EXIST_ANYMORE: 28,
    HOST_LISTING_ALREADY_PHOTOGRAPHED: 29
} as const

export const CHATBOT_ASSIGNMENTS_TASK_STATUSES = {
    ACCEPTED: 'accepted',
    ASSETS_IN_REVIEW: 'assets_in_review',
    AUTO_CANCELLED: 'auto_cancelled',
    COMPLETED: 'completed',
    HARD_CANCELLED: 'hard_cancelled',
    NEEDS_MORE_ASSETS: 'needs_more_assets',
    PENDING: 'pending',
    PENDING_ASSETS: 'pending_assets',
    PENDING_PAYMENT: 'pending_payment',
    SCHEDULED: 'scheduled',
    SOFT_CANCELLED: 'soft_cancelled',
    WAITLISTED: 'waitlisted'
} as const
export type ChatbotAssignmentTaskStatuses =
    (typeof CHATBOT_ASSIGNMENTS_TASK_STATUSES)[keyof typeof CHATBOT_ASSIGNMENTS_TASK_STATUSES]
// Corrected definition for the array
export type ChatbotAssignmentTaskStatusArray = Array<ChatbotAssignmentTaskStatuses>

export type ChatbotOptionType = 'binary' | 'survey'

export type ChatbotReason =
    | 'new_quote'
    | 'wrong_br_number_completed'
    | 'wrong_br_number_completed_notfound'
    | 'wrong_br_number_not_completed'
    | 'wrong_br_number_not_completed_notfound'
    | 'cancel_notready'
    | 'cancel_listingproblem'
    | 'cancel_coordination'
    | 'cancel_noshow'
    | 'compensation_notfound'
    | 'compensation'
    | 'payment_issue'
    | 'generic_ticket'

export type HistoryStep = {
    id: string
    message: string
}

export type ChatbotStep = {
    id: string
    options?: {
        value: string
        label: string
        trigger?: string | (() => string)
    }[]
    message?: string | (() => string)
    trigger?: string | ((obj: {value: unknown; steps: unknown}) => string) | (({value}: {value: string}) => string)
    end?: boolean
    component?: ReactNode | (() => ReactNode)
    asMessage?: boolean
    placeholder?: string
    replace?: boolean
    user?: boolean
    validator?: (value: string | number) => string | boolean
}

export type ChatbotCancellationReason = {
    id: string | null
    text: string | null
}
